<template>
    <div class='clearfix pageTemp'>
        <el-pagination
            class='rt'
            background
            @size-change="handleSizeChange"
            @current-change="changePage"
            :current-page="currentPage"
            :page-size="pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            layout="prev, pager, sizes, next, jumper"
            prev-text='上一页'
            next-text='下一页'
            :total="total">
        </el-pagination>
        <!-- sizes, -->
        <p class='rt' v-if='total'>第{{currentPage}} / {{Math.ceil(total/pageSize)}}页 共{{total}}条</p>
    </div>
</template>
<script>
export default {
    name:'Pagination',
    props:{
        total:{
            type:Number,
            default:0,
            required:true
        },
        pageSize:{
            type:Number,
            default:0,
            required:true
        },
        currentPage:{
            type:Number,
            default:1,
            required:true
        },
        easy:{
            type:Boolean,
            default:true
        }
    },
    data(){
        return{

        }
    },
    methods:{
        changePage(val){
            this.$emit('changePage',val)
        },
        handleSizeChange(val) {
            this.$emit('changePages',val)
      },
    }
}
</script>
<style lang="scss">
    .pageTemp{
        padding:5px 0;
        >p.rt{
            margin-top: 0px;
            line-height: 32px;
            color:#999;
        }
        .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev{
            min-width: 54px;
        }
        .el-pagination.is-background .el-pagination__jump {
            color:#999;
            font-size: 16px;
            margin-right:10px;
        }
        .el-pagination__jump{
            margin-left:10px;
        }

    }
</style>
